import { FC, ReactNode } from 'react';
import classnames from 'classnames';
import { InputGroup, Input, Form } from 'rsuite';
import { RsInputSize, sizeMap } from './size';
import styles from './input.module.scss';

interface RsInputProps {
  value: string;
  onChange: (s: string) => void;
  frontAddon?: ReactNode;
  backAddon?: ReactNode;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  errorMessage?: string | undefined;
  size?: RsInputSize;
}

export const RsInput: FC<RsInputProps> = ({
  value,
  onChange,
  frontAddon = null,
  backAddon = null,
  placeholder = '',
  className = '',
  disabled = false,
  errorMessage = undefined,
  size = RsInputSize.LARGE,
}) => {
  return (
    <div className='rs-form-control-wrapper'>
      <InputGroup
        className={classnames(styles.RsInput, sizeMap[size], className)}
        inside
      >
        {frontAddon && <InputGroup.Addon>{frontAddon}</InputGroup.Addon>}
        <Input
          value={value}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
        />
        {backAddon && <InputGroup.Addon>{backAddon}</InputGroup.Addon>}
      </InputGroup>
      <Form.ErrorMessage
        show={errorMessage !== undefined}
        placement='bottomStart'
      >
        {errorMessage}
      </Form.ErrorMessage>
    </div>
  );
};
